import calculateDiscountedPrice from './calculateDiscountedPrice';
import { discountConfig } from '../../config/discounts';

export const is22DealActive = (basket) => {
    if (!discountConfig.deal22) return false;
    if (!basket || basket.length === 0) return false;
    
    const largeMaskItems = [];
    const shampooItems = [];
    
    basket.forEach(item => {
        const productType = item.productType || '';
        const selectedSize = item.selectedSize || '';
        
        if (productType === "Masky" && selectedSize === "250") {
            largeMaskItems.push({ units: item.units });
        } else if (productType === "Šampony") {
            shampooItems.push({ units: item.units });
        }
    });
    
    const totalLargeMasks = largeMaskItems.reduce((sum, item) => sum + item.units, 0);
    const totalShampoos = shampooItems.reduce((sum, item) => sum + item.units, 0);
    const deal22Count = Math.min(Math.floor(totalLargeMasks / 2), Math.floor(totalShampoos / 2));
    
    return deal22Count > 0;
};

export const is11DealActive = (basket) => {
    if (!discountConfig.deal11) return false;
    if (!basket || basket.length === 0) return false;
    
    const largeMaskItems = [];
    const shampooItems = [];
    
    basket.forEach(item => {
        const productType = item.productType || '';
        const selectedSize = item.selectedSize || '';
        
        if (productType === "Masky" && selectedSize === "250") {
            largeMaskItems.push({ units: item.units });
        } else if (productType === "Šampony") {
            shampooItems.push({ units: item.units });
        }
    });
    
    const totalLargeMasks = largeMaskItems.reduce((sum, item) => sum + item.units, 0);
    const totalShampoos = shampooItems.reduce((sum, item) => sum + item.units, 0);
    const deal11Count = Math.min(totalLargeMasks, totalShampoos);
    
    return deal11Count > 0;
};

export const is111DealActive = (basket) => {
    if (!discountConfig.deal111) return false;
    if (!basket || basket.length === 0) return false;

    const largeMaskItems = [];
    const shampooItems = [];
    const smallColorItems = [];
    
    basket.forEach(item => {
        const productType = item.productType || '';
        const selectedSize = item.selectedSize || '';
        
        if (productType === "Masky" && selectedSize === "250") {
            largeMaskItems.push({ units: item.units });
        } else if (productType === "Šampony") {
            shampooItems.push({ units: item.units });
        } else if ((productType === "Krycí barvy" || productType === "Odstíny") && 
                   (selectedSize === 60 || selectedSize === "60")) {
            smallColorItems.push({ units: item.units });
        }
    });

    const totalLargeMasks = largeMaskItems.reduce((sum, item) => sum + item.units, 0);
    const totalShampoos = shampooItems.reduce((sum, item) => sum + item.units, 0);
    const totalSmallColors = smallColorItems.reduce((sum, item) => sum + item.units, 0);

    return Math.min(totalLargeMasks, totalShampoos, totalSmallColors) > 0;
};

export const is101DealActive = (basket) => {
    if (!discountConfig.deal101) return false;
    if (!basket || basket.length === 0) return false;

    const largeMaskItems = [];
    const smallColorItems = [];

    basket.forEach(item => {
        const productType = item.productType || '';
        const selectedSize = item.selectedSize || '';

        if (productType === "Masky" && selectedSize === "250") {
            largeMaskItems.push({ units: item.units });
        } else if ((productType === "Krycí barvy" || productType === "Odstíny") &&
                   (selectedSize === 60 || selectedSize === "60")) {
            smallColorItems.push({ units: item.units });
        }
    });

    const totalMaskUnits = largeMaskItems.reduce((sum, item) => sum + item.units, 0);
    const totalSmallColors = smallColorItems.reduce((sum, item) => sum + item.units, 0);
    const deal101Count = Math.min(totalMaskUnits, totalSmallColors);

    return deal101Count > 0;
};

export const isMaskColorDiscountActive = (basket) => {
    if (!discountConfig.maskColorDiscount) return false;
    if (!basket || basket.length === 0) return false;

    const largeMaskItems = [];
    const smallColorItems = [];
    
    basket.forEach(item => {
        const productType = item.productType || '';
        const selectedSize = item.selectedSize || '';
        
        if (productType === "Masky" && selectedSize === "250") {
            largeMaskItems.push({ units: item.units });
        } else if ((productType === "Krycí barvy" || productType === "Odstíny") && 
                   (selectedSize === 60 || selectedSize === "60")) {
            smallColorItems.push({ units: item.units });
        }
    });

    const totalMaskUnits = largeMaskItems.reduce((sum, item) => sum + item.units, 0);
    const totalSmallColors = smallColorItems.reduce((sum, item) => sum + item.units, 0);
    const maskColorPairs = Math.min(totalMaskUnits, totalSmallColors);

    return maskColorPairs > 0;
};

export const is21ZdarmaActive = (basket) => {
    if (!discountConfig.deal21Zdarma) return false;
    if (!basket || basket.length === 0) return false;

    const smallColorItems = [];
    
    basket.forEach(item => {
        const productType = item.productType || '';
        const selectedSize = item.selectedSize || '';
        
        if ((productType === "Krycí barvy" || productType === "Odstíny") && 
            (selectedSize === 60 || selectedSize === "60")) {
            smallColorItems.push({ units: item.units });
        }
    });

    const total60mlUnits = smallColorItems.reduce((sum, item) => sum + item.units, 0);
    const free60mlItems = Math.floor(total60mlUnits / 3);

    return free60mlItems > 0;
};

export const calculateTotalWithDiscounts = (basket, onePlusOne = false) => {
    if (!basket || basket.length === 0) return 0;

    // Calculate total price without any deals
    const totalWithoutDeals = basket.reduce((sum, item) => sum + (item.units * item.price), 0);

    // Fixed priority order: Check deals in this order and apply the first applicable one
    // Priority: 1. Deal 2+2, 2. Deal 1+1+1, 3. Deal 1+1, 4. Deal 1+0+1, 5. Mask+Color, 6. Deal 2+1 Free
    
    // Helper function to calculate price if a specific deal is applied
    const calculateWithDeal22 = () => {
        if (!discountConfig.deal22) return null;
        
        const largeMaskItems = [];
        const shampooItems = [];
        
        basket.forEach((item, index) => {
            const productType = item.productType || '';
            const selectedSize = item.selectedSize || '';
            
            if (productType === "Masky" && selectedSize === "250") {
                largeMaskItems.push({ index, units: item.units, price: item.price });
            } else if (productType === "Šampony") {
                shampooItems.push({ index, units: item.units, price: item.price });
            }
        });
        
        const totalLargeMasks = largeMaskItems.reduce((sum, item) => sum + item.units, 0);
        const totalShampoos = shampooItems.reduce((sum, item) => sum + item.units, 0);
        const deal22Count = Math.min(Math.floor(totalLargeMasks / 2), Math.floor(totalShampoos / 2));
        
        if (deal22Count <= 0) return null;
        
        // Calculate price: deal price for deal items + regular price for remaining items
        const dealPrice = deal22Count * 1199;
        let remainingPrice = totalWithoutDeals;
        
        // Subtract the full price of items used in the deal
        let masksUsed = 0;
        let shampoosUsed = 0;
        largeMaskItems.forEach(item => {
            const toUse = Math.min(item.units, (deal22Count * 2) - masksUsed);
            remainingPrice -= toUse * item.price;
            masksUsed += toUse;
        });
        shampooItems.forEach(item => {
            const toUse = Math.min(item.units, (deal22Count * 2) - shampoosUsed);
            remainingPrice -= toUse * item.price;
            shampoosUsed += toUse;
        });
        
        // Ensure remainingPrice doesn't go below 0 due to floating point precision issues
        remainingPrice = Math.max(0, remainingPrice);
        
        // Round to 2 decimal places to avoid floating point precision issues
        return Math.round((dealPrice + remainingPrice) * 100) / 100;
    };

    const calculateWithDeal111 = () => {
        if (!discountConfig.deal111) return null;
        
        const largeMaskItems = [];
        const shampooItems = [];
        const smallColorItems = [];
        
        basket.forEach((item, index) => {
            const productType = item.productType || '';
            const selectedSize = item.selectedSize || '';
            
            if (productType === "Masky" && selectedSize === "250") {
                largeMaskItems.push({ index, units: item.units, price: item.price });
            } else if (productType === "Šampony") {
                shampooItems.push({ index, units: item.units, price: item.price });
            } else if ((productType === "Krycí barvy" || productType === "Odstíny") && 
                      (selectedSize === 60 || selectedSize === "60")) {
                smallColorItems.push({ index, units: item.units, price: item.price });
            }
        });
        
        const totalLargeMasks = largeMaskItems.reduce((sum, item) => sum + item.units, 0);
        const totalShampoos = shampooItems.reduce((sum, item) => sum + item.units, 0);
        const totalSmallColors = smallColorItems.reduce((sum, item) => sum + item.units, 0);
        const deal111Count = Math.min(totalLargeMasks, totalShampoos, totalSmallColors);
        
        if (deal111Count <= 0) return null;
        
        // Calculate price: deal price for deal items + regular price for remaining items
        const dealPrice = deal111Count * 799;
        let remainingPrice = totalWithoutDeals;
        
        // Subtract the full price of items used in the deal
        let masksUsed = 0;
        let shampoosUsed = 0;
        let colorsUsed = 0;
        largeMaskItems.forEach(item => {
            const toUse = Math.min(item.units, deal111Count - masksUsed);
            remainingPrice -= toUse * item.price;
            masksUsed += toUse;
        });
        shampooItems.forEach(item => {
            const toUse = Math.min(item.units, deal111Count - shampoosUsed);
            remainingPrice -= toUse * item.price;
            shampoosUsed += toUse;
        });
        smallColorItems.forEach(item => {
            const toUse = Math.min(item.units, deal111Count - colorsUsed);
            remainingPrice -= toUse * item.price;
            colorsUsed += toUse;
        });
        
        // Ensure remainingPrice doesn't go below 0 due to floating point precision issues
        remainingPrice = Math.max(0, remainingPrice);
        
        // Round to 2 decimal places to avoid floating point precision issues
        return Math.round((dealPrice + remainingPrice) * 100) / 100;
    };

    const calculateWithDeal11 = () => {
        if (!discountConfig.deal11) return null;
        
        const largeMaskItems = [];
        const shampooItems = [];
        
        basket.forEach((item, index) => {
            const productType = item.productType || '';
            const selectedSize = item.selectedSize || '';
            
            if (productType === "Masky" && selectedSize === "250") {
                largeMaskItems.push({ index, units: item.units, price: item.price });
            } else if (productType === "Šampony") {
                shampooItems.push({ index, units: item.units, price: item.price });
            }
        });
        
        const totalLargeMasks = largeMaskItems.reduce((sum, item) => sum + item.units, 0);
        const totalShampoos = shampooItems.reduce((sum, item) => sum + item.units, 0);
        const deal11Count = Math.min(totalLargeMasks, totalShampoos);
        
        if (deal11Count <= 0) return null;
        
        // Calculate price: deal price for deal items + regular price for remaining items
        const dealPrice = deal11Count * 599;
        let remainingPrice = totalWithoutDeals;
        
        // Subtract the full price of items used in the deal
        let masksUsed = 0;
        let shampoosUsed = 0;
        largeMaskItems.forEach(item => {
            const toUse = Math.min(item.units, deal11Count - masksUsed);
            remainingPrice -= toUse * item.price;
            masksUsed += toUse;
        });
        shampooItems.forEach(item => {
            const toUse = Math.min(item.units, deal11Count - shampoosUsed);
            remainingPrice -= toUse * item.price;
            shampoosUsed += toUse;
        });
        
        // Ensure remainingPrice doesn't go below 0 due to floating point precision issues
        remainingPrice = Math.max(0, remainingPrice);
        
        // Round to 2 decimal places to avoid floating point precision issues
        return Math.round((dealPrice + remainingPrice) * 100) / 100;
    };

    const calculateWithDeal101 = () => {
        if (!discountConfig.deal101) return null;

        const largeMaskItems = [];
        const smallColorItems = [];

        basket.forEach((item, index) => {
            const productType = item.productType || '';
            const selectedSize = item.selectedSize || '';

            if (productType === "Masky" && selectedSize === "250") {
                largeMaskItems.push({ index, units: item.units, price: item.price });
            } else if ((productType === "Krycí barvy" || productType === "Odstíny") &&
                      (selectedSize === 60 || selectedSize === "60")) {
                smallColorItems.push({ index, units: item.units, price: item.price });
            }
        });

        const totalMaskUnits = largeMaskItems.reduce((sum, item) => sum + item.units, 0);
        const totalSmallColors = smallColorItems.reduce((sum, item) => sum + item.units, 0);
        const deal101Count = Math.min(totalMaskUnits, totalSmallColors);

        if (deal101Count <= 0) return null;

        const dealPrice = deal101Count * 549;
        let remainingPrice = totalWithoutDeals;

        let masksUsed = 0;
        let colorsUsed = 0;
        largeMaskItems.forEach(item => {
            const toUse = Math.min(item.units, deal101Count - masksUsed);
            remainingPrice -= toUse * item.price;
            masksUsed += toUse;
        });
        smallColorItems.forEach(item => {
            const toUse = Math.min(item.units, deal101Count - colorsUsed);
            remainingPrice -= toUse * item.price;
            colorsUsed += toUse;
        });

        remainingPrice = Math.max(0, remainingPrice);
        return Math.round((dealPrice + remainingPrice) * 100) / 100;
    };

    const calculateWithMaskColorDiscount = () => {
        if (!discountConfig.maskColorDiscount) return null;
        
        const largeMaskItems = [];
        const smallColorItems = [];
        
        basket.forEach((item, index) => {
            const productType = item.productType || '';
            const selectedSize = item.selectedSize || '';
            
            if (productType === "Masky" && selectedSize === "250") {
                largeMaskItems.push({ index, units: item.units, price: item.price });
            } else if ((productType === "Krycí barvy" || productType === "Odstíny") && 
                      (selectedSize === 60 || selectedSize === "60")) {
                smallColorItems.push({ index, units: item.units, price: item.price });
            }
        });
        
        const totalLargeMasks = largeMaskItems.reduce((sum, item) => sum + item.units, 0);
        const totalSmallColors = smallColorItems.reduce((sum, item) => sum + item.units, 0);
        const maskColorPairs = Math.min(totalLargeMasks, totalSmallColors);
        
        if (maskColorPairs <= 0) return null;
        
        // Calculate price: regular price minus 71 Kč discount per pair
        const discount = maskColorPairs * 71;
        // Round to 2 decimal places to avoid floating point precision issues
        return Math.round((totalWithoutDeals - discount) * 100) / 100;
    };

    const calculateWithDeal21Zdarma = () => {
        if (!discountConfig.deal21Zdarma) return null;
        
        const smallColorItems = [];
        
        basket.forEach((item, index) => {
            const productType = item.productType || '';
            const selectedSize = item.selectedSize || '';
            
            if ((productType === "Krycí barvy" || productType === "Odstíny") && 
                (selectedSize === 60 || selectedSize === "60")) {
                smallColorItems.push({ index, units: item.units, price: item.price });
            }
        });
        
        const total60mlUnits = smallColorItems.reduce((sum, item) => sum + item.units, 0);
        const free60mlItems = Math.floor(total60mlUnits / 3);
        
        if (free60mlItems <= 0) return null;
        
        // Calculate price: regular price minus price of free items (cheapest ones)
        const sortedByPrice = [...smallColorItems].sort((a, b) => a.price - b.price); // Sort cheapest first
        
        let freeValue = 0;
        let remainingFree = free60mlItems;
        sortedByPrice.forEach(item => {
            if (remainingFree <= 0) return;
            const toFree = Math.min(item.units, remainingFree);
            freeValue += toFree * item.price;
            remainingFree -= toFree;
        });
        
        // Round to 2 decimal places to avoid floating point precision issues
        return Math.round((totalWithoutDeals - freeValue) * 100) / 100;
    };

    // Apply deals in priority order - return the first applicable deal
    // Priority: 1. Deal 2+2, 2. Deal 1+1+1, 3. Deal 1+1, 4. Deal 1+0+1, 5. Mask+Color, 6. Deal 2+1 Free
    
    const deal22Total = calculateWithDeal22();
    if (deal22Total !== null) {
        return deal22Total;
    }

    const deal111Total = calculateWithDeal111();
    if (deal111Total !== null) {
        return deal111Total;
    }

    const deal11Total = calculateWithDeal11();
    if (deal11Total !== null) {
        return deal11Total;
    }

    const deal101Total = calculateWithDeal101();
    if (deal101Total !== null) {
        return deal101Total;
    }

    const maskColorTotal = calculateWithMaskColorDiscount();
    if (maskColorTotal !== null) {
        return maskColorTotal;
    }

    const deal21ZdarmaTotal = calculateWithDeal21Zdarma();
    if (deal21ZdarmaTotal !== null) {
        return deal21ZdarmaTotal;
    }

    // No deal applicable, return total without discounts
    return totalWithoutDeals;
};

// Function to determine which deal is actually being applied (first applicable deal in priority order)
export const getAppliedDeal = (basket) => {
    if (!basket || basket.length === 0) return null;

    // Fixed priority order: Check deals in this order and return the first applicable one
    // Priority: 1. Deal 2+2, 2. Deal 1+1+1, 3. Deal 1+1, 4. Deal 1+0+1, 5. Mask+Color, 6. Deal 2+1 Free
    
    // Helper function to check if a specific deal is applicable
    const checkDeal22 = () => {
        if (!discountConfig.deal22) return null;
        
        const largeMaskItems = [];
        const shampooItems = [];
        
        basket.forEach((item, index) => {
            const productType = item.productType || '';
            const selectedSize = item.selectedSize || '';
            
            if (productType === "Masky" && selectedSize === "250") {
                largeMaskItems.push({ index, units: item.units, price: item.price });
            } else if (productType === "Šampony") {
                shampooItems.push({ index, units: item.units, price: item.price });
            }
        });
        
        const totalLargeMasks = largeMaskItems.reduce((sum, item) => sum + item.units, 0);
        const totalShampoos = shampooItems.reduce((sum, item) => sum + item.units, 0);
        const deal22Count = Math.min(Math.floor(totalLargeMasks / 2), Math.floor(totalShampoos / 2));
        
        return deal22Count > 0;
    };

    const checkDeal111 = () => {
        if (!discountConfig.deal111) return null;
        
        const largeMaskItems = [];
        const shampooItems = [];
        const smallColorItems = [];
        
        basket.forEach((item, index) => {
            const productType = item.productType || '';
            const selectedSize = item.selectedSize || '';
            
            if (productType === "Masky" && selectedSize === "250") {
                largeMaskItems.push({ index, units: item.units, price: item.price });
            } else if (productType === "Šampony") {
                shampooItems.push({ index, units: item.units, price: item.price });
            } else if ((productType === "Krycí barvy" || productType === "Odstíny") && 
                      (selectedSize === 60 || selectedSize === "60")) {
                smallColorItems.push({ index, units: item.units, price: item.price });
            }
        });
        
        const totalLargeMasks = largeMaskItems.reduce((sum, item) => sum + item.units, 0);
        const totalShampoos = shampooItems.reduce((sum, item) => sum + item.units, 0);
        const totalSmallColors = smallColorItems.reduce((sum, item) => sum + item.units, 0);
        const deal111Count = Math.min(totalLargeMasks, totalShampoos, totalSmallColors);
        
        return deal111Count > 0;
    };

    const checkDeal11 = () => {
        if (!discountConfig.deal11) return null;
        
        const largeMaskItems = [];
        const shampooItems = [];
        
        basket.forEach((item, index) => {
            const productType = item.productType || '';
            const selectedSize = item.selectedSize || '';
            
            if (productType === "Masky" && selectedSize === "250") {
                largeMaskItems.push({ index, units: item.units, price: item.price });
            } else if (productType === "Šampony") {
                shampooItems.push({ index, units: item.units, price: item.price });
            }
        });
        
        const totalLargeMasks = largeMaskItems.reduce((sum, item) => sum + item.units, 0);
        const totalShampoos = shampooItems.reduce((sum, item) => sum + item.units, 0);
        const deal11Count = Math.min(totalLargeMasks, totalShampoos);
        
        return deal11Count > 0;
    };

    const checkDeal101 = () => {
        if (!discountConfig.deal101) return null;

        const largeMaskItems = [];
        const smallColorItems = [];

        basket.forEach((item, index) => {
            const productType = item.productType || '';
            const selectedSize = item.selectedSize || '';

            if (productType === "Masky" && selectedSize === "250") {
                largeMaskItems.push({ index, units: item.units, price: item.price });
            } else if ((productType === "Krycí barvy" || productType === "Odstíny") &&
                      (selectedSize === 60 || selectedSize === "60")) {
                smallColorItems.push({ index, units: item.units, price: item.price });
            }
        });

        const totalMaskUnits = largeMaskItems.reduce((sum, item) => sum + item.units, 0);
        const totalSmallColors = smallColorItems.reduce((sum, item) => sum + item.units, 0);
        const deal101Count = Math.min(totalMaskUnits, totalSmallColors);

        return deal101Count > 0;
    };

    const checkMaskColorDiscount = () => {
        if (!discountConfig.maskColorDiscount) return null;
        
        const largeMaskItems = [];
        const smallColorItems = [];
        
        basket.forEach((item, index) => {
            const productType = item.productType || '';
            const selectedSize = item.selectedSize || '';
            
            if (productType === "Masky" && selectedSize === "250") {
                largeMaskItems.push({ index, units: item.units, price: item.price });
            } else if ((productType === "Krycí barvy" || productType === "Odstíny") && 
                      (selectedSize === 60 || selectedSize === "60")) {
                smallColorItems.push({ index, units: item.units, price: item.price });
            }
        });
        
        const totalLargeMasks = largeMaskItems.reduce((sum, item) => sum + item.units, 0);
        const totalSmallColors = smallColorItems.reduce((sum, item) => sum + item.units, 0);
        const maskColorPairs = Math.min(totalLargeMasks, totalSmallColors);
        
        return maskColorPairs > 0;
    };

    const checkDeal21Zdarma = () => {
        if (!discountConfig.deal21Zdarma) return null;
        
        const smallColorItems = [];
        
        basket.forEach((item, index) => {
            const productType = item.productType || '';
            const selectedSize = item.selectedSize || '';
            
            if ((productType === "Krycí barvy" || productType === "Odstíny") && 
                (selectedSize === 60 || selectedSize === "60")) {
                smallColorItems.push({ index, units: item.units, price: item.price });
            }
        });
        
        const total60mlUnits = smallColorItems.reduce((sum, item) => sum + item.units, 0);
        const free60mlItems = Math.floor(total60mlUnits / 3);
        
        return free60mlItems > 0;
    };

    // Check deals in priority order - return the first applicable one
    if (checkDeal22()) {
        return 'deal22';
    }

    if (checkDeal111()) {
        return 'deal111';
    }

    if (checkDeal11()) {
        return 'deal11';
    }

    if (checkDeal101()) {
        return 'deal101';
    }

    if (checkMaskColorDiscount()) {
        return 'maskColor';
    }

    if (checkDeal21Zdarma()) {
        return 'deal21Zdarma';
    }

    // No deal applicable
    return null;
};

export default calculateTotalWithDiscounts;
